export default __webpack_public_path__ + "static/media/icoInstagram.1e3d0702.svg";